export default "__VITE_ASSET__CG1m75Fd__"